import config from './config.js'
import convert from 'xml-js'

export default async (xml, method) => {
  const properties = config.methods[method]

  const convertOptions = config.xml2js.convertOptions

  const parsedData = convert.xml2js(xml, convertOptions)

  if (parsedData['S:Envelope']['S:Body'][properties.responseTag].return['ns3:resultId']._ !== 9000) {
    throw new Error(parsedData['S:Envelope']['S:Body'][properties.responseTag].return['ns3:resultMessage']._)
  }

  if (Array.isArray(properties.dataTag)) {
    return properties.dataTag.reduce((obj, tag) => {
      return {...obj, ...{[tag]: parsedData['S:Envelope']['S:Body'][properties.responseTag].return[tag] || null}}
    }, {})
  }

  const dataExtracted = parsedData['S:Envelope']['S:Body'][properties.responseTag].return[properties.dataTag]

  if (dataExtracted && !Array.isArray(dataExtracted)) return [dataExtracted]
  
  return dataExtracted
}
